import { serviceURL } from './service-url'

const callbackFields = ['code', 'state', 'error', 'error_description']

export function getEmailOAuthRelay(sourceURL, apiBase = serviceURL) {
  const source = new URL(sourceURL)
  const state = source.searchParams.get('state')
  if (
    !state?.startsWith('email_') ||
    !(source.searchParams.get('code') || source.searchParams.get('error'))
  ) {
    return null
  }
  if (typeof apiBase !== 'string' || !apiBase.trim()) {
    throw new Error('Email callback API is unavailable')
  }
  const callback = new URL(apiBase, source.origin)
  if (
    !['http:', 'https:'].includes(callback.protocol) ||
    callback.username ||
    callback.password ||
    (source.protocol === 'https:' && callback.protocol !== 'https:')
  ) {
    throw new Error('Email callback API is unavailable')
  }
  callback.pathname = `${callback.pathname.replace(/\/+$/, '')}/email-integration/oauth/callback`
  callback.search = ''
  callback.hash = ''
  const fields = Object.fromEntries(
    callbackFields
      .filter((name) => source.searchParams.has(name))
      .map((name) => [name, source.searchParams.get(name)])
  )
  return { action: callback.toString(), fields }
}

// This is the only bootstrap dependency for a Google email return.
export function relayEmailOAuthCallback(location = window.location) {
  let relay
  try {
    relay = getEmailOAuthRelay(location.href)
  } catch {
    window.history.replaceState(null, '', location.pathname)
    document.getElementById('root').textContent =
      'A conexão de email não pôde ser concluída. Contate o administrador para verificar a configuração da API.'
    return true
  }
  if (!relay) return false

  window.history.replaceState(null, '', location.pathname)
  const form = document.createElement('form')
  form.method = 'POST'
  form.enctype = 'application/x-www-form-urlencoded'
  form.action = relay.action
  form.hidden = true
  for (const [name, value] of Object.entries(relay.fields)) {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    form.appendChild(input)
  }
  document.body.appendChild(form)
  form.submit()
  return true
}
